import { SharedModule } from './../shared/shared.module';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './component/header/header.component';
import { SideBarComponent } from './component/side-bar/side-bar.component';
import {MaterialModule} from '../other-modules/matmodules/material.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './component/login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { VideoListComponent } from './component/video-list/video-list.component';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';




@NgModule({
  declarations: [HeaderComponent, SideBarComponent,LoginComponent,VideoListComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    SharedModule,
    MatSelectModule,
    MatFormFieldModule,
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    MatTooltipModule
  ],
  exports: [
    HeaderComponent ,
    SideBarComponent,
    LoginComponent,
    VideoListComponent,
    BrowserModule ,
    BrowserAnimationsModule
  ]
})
export class CoreModule { }
